import { useCallback } from 'react';
import { FormCheckboxGroupInputComponent } from 'src/features/generalForms/builder/types/CheckboxGroupInput';
import { AnswerPreviewRow } from '../previewRow/answerPreviewRow';
import { RPDF } from 'src/features/report/react-pdf';
import { useAnswerValue } from 'src/features/generalForms/answerPreview/hooks/useAnswerValue';
import { useAnswerRowConditional } from 'src/features/generalForms/answerPreview/hooks/useAnswerRowConditional';

export const FormCheckboxGroupInput: FormCheckboxGroupInputComponent = (props) => {
  const value = useAnswerValue(props.dataKey!);
  const renderValue = useCallback(
    (arr: string[]) =>
      props.options
        ?.filter((opt) => arr?.includes(opt.key))
        .map((opt) => opt.value)
        .join(', ') ?? '',
    [props.options],
  );

  const { visible } = useAnswerRowConditional();
  if (!visible) {
    return <RPDF.View />;
  }

  if (props.isOptional && !props.title && !value?.length) return <RPDF.View />;

  return <AnswerPreviewRow<string[]> value={value} renderValue={renderValue} {...props} />;
};
